class DashboardAccount {
  // Photo
  private photoWrap: HTMLElement | null;
  private fileInput?: HTMLInputElement | null;
  private uploadButton?: HTMLButtonElement | null;
  private photoAccount?: HTMLImageElement | null;

  // Password
  private passwordForm: HTMLFormElement | null;
  private input?: HTMLInputElement | null
  private confirmInput?: HTMLInputElement | null
  private helpText?: HTMLElement | null
  private submitBtn?: HTMLButtonElement | null

  // Regex : 8 caractères, 1 Maj, 1 Min, 1 chiffre et 1 Spécial
  private readonly regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[\W]).{8,}$/;

  constructor() {
    // Containers
    this.photoWrap = document.querySelector('.dashboard-account__group--photo');
    this.passwordForm = document.querySelector('.dashboard-account__password');

    // Initialisation Photo
    if (this.photoWrap) {
      this.fileInput = this.photoWrap.querySelector(".dashboard-account__photo-input");
      this.uploadButton = this.photoWrap.querySelector(".btn");
      this.photoAccount = this.photoWrap.querySelector(".dashboard-account__photo");
      this._initPhoto();
    }

    // Initialisation Password
    if (this.passwordForm) {
      this.input = this.passwordForm.querySelector('input[name="pass1"]');
      this.confirmInput = this.passwordForm.querySelector('input[name="pass2"]');
      this.helpText = this.passwordForm.querySelector('.dashboard-account__password-help');
      this.submitBtn = this.passwordForm.querySelector('button[type="submit"]');
      this._initPassword();
    }
  }

  private _initPhoto(): void {
    if (!this.uploadButton || !this.fileInput) return;

    this.uploadButton.addEventListener("click", (event: MouseEvent) => {
      event.preventDefault();
      this.fileInput?.click();
    });

    this.fileInput.addEventListener("change", async () => {
      const file = this.fileInput?.files?.[0];
      if (!file) return;

      const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
      if (!allowedTypes.includes(file.type)) {
        alert("Seuls les fichiers JPG et PNG sont autorisés.");
        return;
      }

      const formData = new FormData();
      formData.append("action", "user_photo_upload");
      formData.append("file", file);
      formData.append("nonce", (window as any).ajax?.nonce);

      try {
        const response = await fetch((window as any).ajax?.ajax_url, {
          method: "POST",
          body: formData,
        });

        const result = await response.json();

        if (result.success && this.photoAccount) {
          const src = result.data;
          this.photoAccount.src = src;
        } else {
          console.error("Erreur lors de l'upload :", result.data);
        }
      } catch (error) {
        console.error("Erreur réseau ou serveur :", error);
      }
    });
  }

  private _initPassword(): void {
    if (!this.input) return;

    // Validation au fur et à mesure de la saisie
    this.input.addEventListener('input', () => this.validate());
    if (this.confirmInput) {
      this.confirmInput.addEventListener('input', () => this.validate());
    }
  }

  private validate(): void {
    if (!this.input || !this.helpText || !this.submitBtn) return;

    const value = this.input.value;
    const isComplexEnough = this.regex.test(value);

    // Vérification de correspondance (optionnel mais recommandé)
    const passwordsMatch = this.confirmInput ? value === this.confirmInput.value : true;

    // Mise à jour visuelle du message d'aide
    if (value.length > 0) {
      this.helpText.style.color = isComplexEnough ? '#27ae60' : '#e74c3c';
    }

    // Gestion de l'état du bouton
    const isValid = isComplexEnough && passwordsMatch;
    this.submitBtn.disabled = !isValid;
    this.submitBtn.style.opacity = isValid ? '1' : '0.5';
    this.submitBtn.style.cursor = isValid ? 'pointer' : 'not-allowed';
  }
}

export const dashboardAccount = new DashboardAccount();